import React from 'react';
import { IFutureOrder } from '@sp-types/FutureOrderType';

interface Props {
  orderIdParam?: string;
  futureOrder: IFutureOrder;
  onLoad: (_orderType: string) => void;
}
export const FutureOrderSummaryRedirector: React.FC<Props> = ({ onLoad, futureOrder, orderIdParam }) => {
  React.useEffect(() => {
    if (futureOrder?.futureOrderType && orderIdParam && orderIdParam === futureOrder.uuid) {
      onLoad(futureOrder?.futureOrderType);
    }
  }, [futureOrder?.uuid, orderIdParam]);

  return <div className="w-full h-20 animate-pulse rounded-md text-gray-50">loading</div>;
};
